import { FC } from 'react';
import Comment from '@mui/icons-material/Comment';
import { FixtureAction } from '@/service/types';
import { ARIA_LABEL } from '@/constants/ariaLabel';
import { CustomTooltip } from '../StatsCompareTable/StyledStatsComponents';
import { AnimatedIconButton } from '../common/AnimatedIconButton';
import { BUTTON_NAME } from './constants';

export interface CommentCellProps {
  action: FixtureAction;
}

export const CommentCell: FC<CommentCellProps> = ({ action }) => {
  const noComment = !action.comment || !action.comment.length;

  if (noComment) {
    return <span />;
  }

  const previewComment = `Comment: ${action.comment}`;

  return (
    <CustomTooltip title={previewComment}>
      <AnimatedIconButton
        name={BUTTON_NAME.COMMENT}
        size='small'
        aria-label={ARIA_LABEL.COMMENTS}
      >
        <Comment fontSize='small' />
      </AnimatedIconButton>
    </CustomTooltip>
  );
};
